import { Component, OnInit, } from '@angular/core';
import { SIDENAV_DATA_MODULES } from '../../constants/side-nav.cnst';
import { WebServiceService } from '../../services/web-service.service';

@Component({
  selector: 'lib-web-sidenav-content',
  templateUrl: './web-sidenav-content.component.html',
  styleUrls: ['./web-sidenav-content.component.scss']
})
export class WebSidenavContentComponent implements OnInit {

  sideNavOptions = SIDENAV_DATA_MODULES;
  selectedOptionName: string = "default";

  constructor( private webService: WebServiceService) {}

  //for setting value of selectedOption;
  ngOnInit() {
    this.webService.selectedOption$.subscribe( (option: any) => {
      this.selectedOptionName = option.label;
    })
  }
}
